import React, { useState, useEffect } from "react";
import "./CustomNavbarToggle.css";
/**
 *
 * CustomNavBarToggle is a custom built component that renders a navbar toggler to use instead of the in built bootstrap one.
 * It has an animation which improves the UI of the web application increasing its appeal.
 * @param {Object} props.onClick is the event handler for the toggle
 * @returns a react element
 */
const CustomNavbarToggle = ({ onClick, active }) => {
    const [isActive, setIsActive] = useState(active); // destructured to use like a switch

    // Update isActive state when the active prop changes
    useEffect(() => {
        setIsActive(active);
    }, [active]);

    const toggleActive = () => {
        const newActive = !isActive;
        setIsActive(newActive);
        onClick(newActive);
    };

    return (
        <svg
            className={`ccl_ham ccl_hamRotate ccl_ham1 ${
                isActive ? "active" : ""
            } d-block d-md-none rounded`}
            viewBox="0 0 100 100"
            width="48"
            onClick={toggleActive}
        >
            <path
                className="ccl_line ccl_top"
                d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
            />
            <path className="ccl_line ccl_middle" d="m 30,50 h 40" />
            <path
                className="ccl_line ccl_bottom"
                d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
            />
        </svg>
    );
};

export default CustomNavbarToggle;
